



















































































































































































































































































































































































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";
dayjs.extend(duration);
dayjs.extend(relativeTime);

@Component({
  components: {},
})
export default class BulkFeedback extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  @Prop() private companyId!: string;
  @Prop() private accountId!: string;
  @Prop() private jobId!: string;
  @Prop({ default: () => 1 }) private page!: number;

  private pageNumber = this.page;
  private loading = true;
  private sortTypeASC = false;
  private paginationRowsPerPage = 20;
  private paginationTotalRecords = 0;

  private jobDetails: any = {};
  private jobItems = [];
  private jobColumns: any = [];
  private jobColumnOptions: any = [];
  private currentSortField =
    this.jobColumns.length > 0 ? this.jobColumns[0] : "";
  private selectedRows: number[] = [];
  private errorMessage = "";
  private showFilters = false;
  private filters: any = {};
  private appliedFilters: any = {};
  private taxcodeData: any[] = [];
  private selectedTaxcode = "";
  private selectedTaxcodeDescription = "";
  private customerComment = "";
  private filterResetKey = 0;
  private dialogLoaderText = "";
  private hasUnsavedChanges = false;
  private showSetupImage = false;

  private stepsByRoles = {
    customerOrRepWithSupport: [
      "Upload product catalog",
      "Fill Questionare",
      "Review and create",
    ],
    customerOrRepWithoutSupport: [
      "Upload product catalog",
      "Fill Questionare",
      "Map columns",
      "Select profile/categories",
      "Review and create",
    ],
    expert: [
      "Upload product catalog",
      "Fill Questionare",
      "Upload curated catalog",
      "Map columns",
      "Select profile/categories",
      "Review and create",
    ],
  };

  async mounted() {
    this.$store.commit("startLoading");
    this.loading = true;
    await this.setupJob();
  }

  backToJob() {
    if (this.hasUnsavedChanges) {
      this.openDialog("unload_dialog");
    } else {
      this.$router.push({
        path: `/classification/${this.accountId}/${
          this.companyId
        }/jobs/create?jobId=${this.jobId}&step=${this.jobStep()}`,
      });
    }
  }

  getSteps(jobDetails) {
    if (this.$store.state.herculeRole === "ClassificationInternalExpert") {
      return this.stepsByRoles["expert"];
    } else {
      const isFullClassificationAdmin =
        this.$store.state.herculeRole === "ClassificationAdmin" &&
        this.$store.getters.featureLevel("item-classification") === "full";
      if (isFullClassificationAdmin) {
        return jobDetails.metadata.support &&
          jobDetails.metadata.support == "true"
          ? this.stepsByRoles["customerOrRepWithSupport"]
          : this.stepsByRoles["customerOrRepWithoutSupport"];
      } else {
        return this.stepsByRoles["customerOrRepWithSupport"];
      }
    }
  }

  backWithoutSave() {
    this.closeDialog("unload_dialog");
    this.$router.push({
      path: `/classification/${this.accountId}/${
        this.companyId
      }/jobs/create?jobId=${this.jobId}&step=${this.jobStep()}`,
    });
  }

  async saveBeforeBack() {
    this.closeDialog("unload_dialog");
    await this.saveDraft();
    this.$router.push({
      path: `/classification/${this.accountId}/${
        this.companyId
      }/jobs/create?jobId=${this.jobId}&step=${this.jobStep()}`,
    });
  }

  jobStep() {
    const job = this.jobDetails;
    const categoryStepCompleted = job.categories && job.categories.length > 0;
    const fieldMappingStepCompleted =
      job.metadata.field_mapping_source &&
      job.metadata.field_mapping_source === "user" &&
      Object.keys(job.fieldMapping).length > 0;
    const curatedUploadStepCompleted = "curatedFileName" in job.metadata;
    const questionareStepCompleted = job.metadata.isQuestionnaireDone == "true";
    const uploadStepCompleted =
      job.metadata.fileName && job.metadata.fileName !== "";
    const steps = this.getSteps(job);
    const conditionByStepName = {
      "Upload product catalog": uploadStepCompleted,
      "Fill Questionare": questionareStepCompleted,
      "Upload curated catalog": curatedUploadStepCompleted,
      "Map columns": fieldMappingStepCompleted,
      "Select profile/categories": categoryStepCompleted,
      "Review and create": false,
    };
    let step = 0;
    for (step = 0; step <= steps.length - 1; step++) {
      const stepName = steps[step];
      if (!conditionByStepName[stepName]) break;
    }

    return step;
  }

  async setupJob() {
    this.$api
      .get(`item-classification-api/v1/jobs/${this.companyId}/${this.jobId}`)
      .then(async (response) => {
        this.jobDetails = response.data;
        if (this.jobDetails.status != "IN FEEDBACK") {
          this.$store.commit("stopLoading");
          this.loading = false;
          this.dialogLoaderText =
            "Setting up the feedback for you, please come back after sometime..";
          this.showSetupImage = true;
          setTimeout(async () => {
            await this.setupJob();
          }, 500);
        } else {
          this.dialogLoaderText = "";
          this.showSetupImage = false;
          await this.populateJobsList();
          this.filters = {
            fieldsToHide: [
              "code_1",
              "code_2",
              "code_3",
              "description_1",
              "description_2",
              "description_3",
              "UPC_lookup_code",
              "UPC_lookup_confidence",
              "delivery_method",
            ],
            rowsFilterBy: [
              { col: this.jobColumns[0], action: "contains", value: "" },
              { col: this.jobColumns[0], action: "contains", value: "" },
              { col: this.jobColumns[0], action: "contains", value: "" },
            ],
          };
          this.appliedFilters = Object.assign({}, this.filters);
          this.$watch("appliedFilters", this.populateJobsList);
        }
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.loading = false;
        const errorCode = (error as any).response.data.code;
        if (_.has(errorsUtil.errorMessages, errorCode)) {
          this.$store.commit("recordError", "");
          this.errorMessage = errorsUtil.errorMessages[errorCode];
        }
      });
  }

  async resetFilters(e) {
    this.filterResetKey = this.filterResetKey + 1;
    this.toggleFiltersPanel();
    this.filters = {
      fieldsToHide: [],
      rowsFilterBy: [
        { col: this.jobColumns[0], action: "contains", value: "" },
        { col: this.jobColumns[0], action: "contains", value: "" },
        { col: this.jobColumns[0], action: "contains", value: "" },
      ],
    };
    this.dialogLoaderText =
      "Autosaving any unsaved changes before moving away from this page";
    await this.saveDraft();
    this.dialogLoaderText = "";
    this.appliedFilters = Object.assign({}, this.filters);
  }

  async applyFilters(e: any) {
    this.dialogLoaderText =
      "Autosaving any unsaved changes before moving away from this page";
    await this.saveDraft();
    this.dialogLoaderText = "";
    this.appliedFilters = Object.assign({}, this.filters);
  }

  jobColumnsWithoutHidden() {
    return this.jobColumns.filter(
      (col) =>
        this.appliedFilters.fieldsToHide &&
        this.appliedFilters.fieldsToHide.indexOf(col) < 0
    );
  }

  onSelectHideFilterColumn(e) {
    Vue.set(this.filters, "fieldsToHide", [
      ...this.filters.fieldsToHide,
      e.detail.item.value,
    ]);
  }

  onDeselectHideFilterColumn(e) {
    Vue.set(
      this.filters,
      "fieldsToHide",
      this.filters.fieldsToHide.filter((v) => v != e.detail.item.value)
    );
  }

  onSelectRowFilterColumn(e, index) {
    const updated = _.set(
      this.filters,
      `rowsFilterBy[${index}].col`,
      e.detail.item.value
    );
    this.filters = updated;
  }

  onSelectRowFilterAction(e, index) {
    const updated = _.set(
      this.filters,
      `rowsFilterBy[${index}].action`,
      e.detail.item.value
    );
    this.filters = updated;
  }

  @Watch("currentSortField")
  @Watch("sortTypeASC")
  async populateJobsList() {
    this.loading = true;
    this.$store.commit("startLoading");
    try {
      const skip = this.paginationStartIndex();
      const top = this.paginationRowsPerPage;
      const orderBy =
        this.currentSortField != ""
          ? "&orderBy=" +
            '"' +
            this.currentSortField +
            '"' +
            (this.sortTypeASC ? " ASC" : " DESC")
          : "";
      const currentApplied = Object.assign({}, this.appliedFilters);
      const filters = currentApplied.rowsFilterBy
        ? currentApplied.rowsFilterBy
            .map((f) => `"${f.col}" ${f.action} '${f.value}'`)
            .join(" and ")
        : "";
      const filterQuery = filters == "" ? "" : "&filter=" + filters;
      const jobItemsResponse = await this.$api.get(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/feedback?skip=${skip}&top=${top}${orderBy}${filterQuery}`
      );
      this.paginationTotalRecords = jobItemsResponse.data.recordsetCount;
      this.jobItems = jobItemsResponse.data.value;
      this.jobColumns =
        this.jobItems.length > 0 ? Object.keys(this.jobItems[0]) : [];
      this.jobColumnOptions = this.jobColumns.map((col) => {
        return { label: col, value: col };
      });
      this.selectedRows = [];
      this.$store.commit("stopLoading");
      this.loading = false;
    } catch (error) {
      const errorCode = (error as any).response.data.code;
      if (_.has(errorsUtil.errorMessages, errorCode)) {
        this.$store.commit("recordError", "");
        this.errorMessage = errorsUtil.errorMessages[errorCode];
      }
      this.$store.commit("stopLoading");
      this.loading = false;
    }
  }

  public onTaxCodeSelect(e: any): void {
    this.selectedTaxcode = e.detail.item.value;
    this.selectedTaxcodeDescription = e.detail.item.label;
  }

  async onTaxcodeInputChanged(e: any) {
    this.$store.commit("startLoading");
    const searchQuery: string = e.detail.inputValue.trim();
    const pattern = /^([a-zA-Z0-9 ,]*)$/;
    if (searchQuery === "" || !pattern.test(searchQuery)) return;
    try {
      const response = await this.$api.get(
        `/api/taxcode_autosuggest/?searchterm=${searchQuery}`
      );
      this.$store.commit("stopLoading");
      this.taxcodeData = response.data.results.map((result) => {
        return {
          label: `${result.code} - ${result.short_desc.replace(
            /\s{2,}/g,
            " "
          )}`,
          value: result.code,
          selected: undefined,
        };
      });
    } catch (error) {
      const errorCode = (error as any).response.data.code;
      if (_.has(errorsUtil.errorMessages, errorCode)) {
        this.$store.commit("recordError", "");
        this.errorMessage = errorsUtil.errorMessages[errorCode];
      }
      this.$store.commit("stopLoading");
      this.loading = false;
    }
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessage = errorsUtil.errorMessages[errorCode];
    }
  }

  async saveDraft() {
    try {
      this.loading = true;
      this.$store.commit("startLoading");
      const saveResponse = await this.$api.put(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/feedback/save`,
        this.jobItems
      );
      this.$store.commit("stopLoading");
      this.loading = false;
      this.hasUnsavedChanges = false;
    } catch (error) {
      const errorCode = (error as any).response.data.code;
      if (_.has(errorsUtil.errorMessages, errorCode)) {
        this.$store.commit("recordError", "");
        this.errorMessage = errorsUtil.errorMessages[errorCode];
      }
      this.$store.commit("stopLoading");
      this.loading = false;
    }
  }

  verifyRecords() {
    this.selectedRows.forEach((rowIndex) => {
      const currentRow = this.jobItems[rowIndex];
      const updatedRow = Object.assign(currentRow, {
        /* eslint-disable @typescript-eslint/camelcase */
        customer_review_status: "Verified",
      });
      Vue.set(this.jobItems, rowIndex, updatedRow);
    });
    this.closeDialog("verify-records");
    this.selectedRows = [];
    this.hasUnsavedChanges = true;
  }

  modifyRecords() {
    const taxcode = this.selectedTaxcode;
    const comment = this.customerComment;
    this.selectedRows.forEach((rowIndex) => {
      const currentRow = this.jobItems[rowIndex];
      const updatedRow = Object.assign(currentRow, {
        /* eslint-disable @typescript-eslint/camelcase */
        final_tax_code: taxcode,
        feedback_comments: comment,
        customer_review_status: "Modified",
        final_tax_code_desc: this.selectedTaxcodeDescription,
      });
      Vue.set(this.jobItems, rowIndex, updatedRow);
    });
    this.closeDialog("modify-records");
    this.selectedRows = [];
    this.hasUnsavedChanges = true;
  }

  private openDialog(refId) {
    this.selectedTaxcode = "";
    this.customerComment = "";
    this.taxcodeData = [];
    (this.$refs[refId] as any).showModal();
  }

  private closeDialog(refId) {
    (this.$refs[refId] as any).close();
  }

  toggleFiltersPanel() {
    this.showFilters = !this.showFilters;
  }

  onAllRowsClick() {
    this.selectedRows =
      this.selectedRows.length == this.jobItems.length
        ? []
        : [...Array(this.jobItems.length).keys()];
  }

  onRowClick(index) {
    this.selectedRows =
      this.selectedRows.indexOf(index) >= 0
        ? this.selectedRows.filter((num) => num != index)
        : this.selectedRows.concat(index);
  }

  async finishFeedback() {
    try {
      await this.saveDraft();
      this.$store.commit("startLoading");
      this.loading = true;
      const saveResponse = await this.$api.post(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/feedback/publish`
      );
      this.$router.replace({
        path: `/classification/${this.accountId}/${this.companyId}/jobs`,
      });
      this.$store.commit("stopLoading");
    } catch (error) {
      const errorCode = (error as any).response.data.code;
      if (_.has(errorsUtil.errorMessages, errorCode)) {
        this.$store.commit("recordError", "");
        this.errorMessage = errorsUtil.errorMessages[errorCode];
      }
      this.$store.commit("stopLoading");
      this.loading = false;
    }
  }

  private paginationStartIndex() {
    return (this.pageNumber - 1) * this.paginationRowsPerPage;
  }

  async onPageChange(e: any) {
    const hasPageChanged =
      e.detail.currentPage !== 0 && e.detail.currentPage !== this.pageNumber;
    const hasRowsPerPageChanged =
      e.detail.rowsPerPage !== this.paginationRowsPerPage;
    if (hasPageChanged) {
      this.pageNumber = e.detail.currentPage;
      const query = Object.assign({}, this.$route.query);
      query.page = e.detail.currentPage;
      this.$router.push({ query });
    }
    this.paginationRowsPerPage = e.detail.rowsPerPage;
    this.dialogLoaderText =
      "Autosaving any unsaved changes before moving away from this page";
    await this.saveDraft();
    this.dialogLoaderText = "";
    if (hasPageChanged || hasRowsPerPageChanged) await this.populateJobsList();
  }

  private formatDate(date) {
    return dayjs(date).format("YYYY/MM/DD");
  }

  async onSortChange(field) {
    this.dialogLoaderText =
      "Autosaving any unsaved changes before moving away from this page";
    await this.saveDraft();
    this.dialogLoaderText = "";
    if (this.currentSortField === field) this.sortTypeASC = !this.sortTypeASC;
    else {
      this.currentSortField = field;
      this.sortTypeASC = false;
    }
  }

  sortIconType(field) {
    if (this.currentSortField === field)
      return this.sortTypeASC ? "arrow-up" : "arrow-down";
    return "arrow-down";
  }
}
